import "./WeatherCard.css";

function toF(c) {
  return Math.round((c * 9) / 5 + 32);
}

function formatDate(timestamp) {
  const date = new Date(timestamp * 1000);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  return `${days[date.getDay()]} ${hours}:${minutes}`;
}

export default function WeatherCard({ weather, unit, onUnitChange, loading }) {
  if (loading) {
    return (
      <div className="weather-card">
        <p className="loading">Loading weather... ☁️</p>
      </div>
    );
  }

  if (!weather) return null;

  const tempC = Math.round(weather.temperature.current);
  const feelsC = Math.round(weather.temperature.feels_like ?? weather.temperature.current);
  const displayTemp = unit === "C" ? tempC : toF(tempC);

  return (
    <div className="weather-card">
      <div className="weather-header">
        <div className="weather-left">
          <h1 className="city-name">{weather.city}</h1>
          <p className="weather-date">{formatDate(weather.time)}</p>
          <p className="weather-description">{weather.condition.description}</p>
        </div>

        <div className="weather-right">
          <img
            src={`http://shecodes-assets.s3.amazonaws.com/api/weather/icons/${weather.condition.icon}.png`}
            alt={weather.condition.description}
            className="weather-icon"
          />
          <div className="temp-block">
            <div className="temperature">
              {displayTemp}<span className="degree">°</span>
            </div>
            <div className="unit-toggle">
              <span
                className={unit === "C" ? "active" : ""}
                onClick={() => onUnitChange("C")}
              >C</span>
              &nbsp;|&nbsp;
              <span
                className={unit === "F" ? "active" : ""}
                onClick={() => onUnitChange("F")}
              >F</span>
            </div>
          </div>
        </div>
      </div>

      <div className="weather-details">
        <div>💧 Humidity: <strong>{weather.temperature.humidity}%</strong></div>
        <div>💨 Wind: <strong>{Math.round(weather.wind.speed)} km/h</strong></div>
      </div>
    </div>
  );
}
